import 'whatwg-fetch'
import React, {Component, lazy, Suspense} from 'react'
import {actions as kandyActions} from 'kandy-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from '../components/Header'
import {agentActions, dashboardActions, serviceRequestActions, currentCallActions} from '../actions'
import {screenShotActions, report, reportPreviewActions, serviceRequestPiccActions} from '../lossAss/actions'
import t from '../localization'

export const TrtcRoom = lazy(() => import('../components/TrtcRoom'))

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    
    renderNotice() {
        const {location} = this.props;

        if (location.pathname === '/') {
            return (
                <h4 style={ {
                    textAlign: 'center',
                    top: '100px',
                    position: 'relative'
                } }>{t('App::wrongUrlTryAgain')}</h4>
            )
        } else {
            return null
        }
    }

    renderHeader() {
        const {actions, currentAgent, currentCustomerCount, dashboard, routerState, session, location} = this.props;
        if (location.pathname.indexOf('login') > -1) {

            return (undefined)
        } else {

            return (<Header
                actions={actions}
                currentAgent={currentAgent}
                currentCustomerCount={currentCustomerCount}
                dashboard={dashboard}
                routerState={routerState}
                session={session}
                history={this.props.history}
            />)
        }
    }


    render() {
        const {children, currentCall, actions, currentAgent, calls, reportPreview, customers, currentCustomerCount} = this.props;
        let videoHtml;
        if(currentCall && currentCall.currentCustomer && currentCall.currentCustomer.channelType.indexOf('trtc') > -1) {
            videoHtml = <Suspense fallback={<div style={{ textAlign: 'center', margin: 20 }}>加载中...</div>}>
                <TrtcRoom call={currentCall} currentAgent={currentAgent} currentCustomerCount={currentCustomerCount} customers={customers} actions={actions} reportPreview={reportPreview}/>
            </Suspense>
            
        }
        return (
            <React.Fragment>
                {videoHtml}
                {this.renderHeader()}
                {this.renderNotice()}
                {children}
                {/* <UploadNotification /> */}
            </React.Fragment>
        )
    }
}

App.propTypes = {
    children: PropTypes.node
};

let mapStateToProps = (state) => {
    return {
        companyId: state.company.id,
        currentAgent: state.app.currentAgent.userInfo,
        currentCustomerCount: state.app.customers.current.length,
        dashboard: state.app.dashboard,
        routerState: state.router,
        session: state.app.kandy.auth,
        currentCall: state.app.currentCall,
        calls: state.app.kandy.calls,
        reportPreview: state.lossAss.reportPreview,
        customers: state.app.customers.current
    }
};

let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, kandyActions, agentActions, dashboardActions, serviceRequestActions,
            currentCallActions, screenShotActions, report, reportPreviewActions, serviceRequestPiccActions), dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(App))
